let StepStatus = /*#__PURE__*/function (StepStatus) {
  StepStatus["STATUS_CURRENT"] = "current";
  StepStatus["STATUS_DISABLED"] = "disabled";
  StepStatus["STATUS_COMPLETED"] = "completed";
  return StepStatus;
}({});

export { StepStatus };
//# sourceMappingURL=status.js.map
